import { useState } from 'react'
import { OptionMenu } from '~/components/option-menu'
import { useInputMultiSelectContext } from '../../input-multi-select'
import type {
  InputMultiSelectDropdownProps,
  InputMultiSelectQuantity,
  InputMultiSelectScopedProps,
} from '../../input-multi-select.types'

export const InputMultiSelectDropdown = ({
  labels,
  selectedLabels,
  onCancel,
  onConfirm,
  __scopeInputMultiSelect,
}: InputMultiSelectScopedProps<InputMultiSelectDropdownProps>) => {
  const { isActive, setActive } = useInputMultiSelectContext(
    'InputMultiSelectActions',
    __scopeInputMultiSelect
  )

  const [selectedList, setSelectedList] =
    useState<InputMultiSelectQuantity[]>(selectedLabels)

  const isChecked = (itemId: string) =>
    !!selectedList.find(({ id }) => id === itemId)

  const handlePress = (checked: boolean, item: InputMultiSelectQuantity) => {
    setSelectedList(
      checked
        ? selectedList.filter(({ id }) => id !== item.id)
        : [...selectedList, item]
    )
  }

  return (
    <OptionMenu.Root>
      <OptionMenu.List>
        {labels.map(item => (
          <OptionMenu.Item
            key={item.id}
            type="multi"
            checked={isChecked(item.id)}
            content={{ label: item.label, value: item.id }}
            customColor="colorTextNeutralDefault"
            onPress={() => handlePress(isChecked(item.id), item)}
          />
        ))}
      </OptionMenu.List>
      <OptionMenu.Footer
        controls={[
          {
            type: 'cancel',
            label: 'Cancelar',
            handler: () => {
              setActive(!isActive)
              onCancel()
            },
          },
          {
            type: 'confirm',
            label: 'Confirmar',
            handler: () => {
              setActive(!isActive)
              onConfirm(selectedList)
            },
          },
        ]}
      />
    </OptionMenu.Root>
  )
}
